export default class ApolloDataExportItem
{
	constructor(item) 
	{
		if(item===undefined)
		{
			this.ApolloDataExportHistoryId="";
			this.ApolloDataExportId="";
			this.CreatedOn="";
			this.EventDescription="";
		}
		else
		{
			this.initialize(item);
		}
	}

	async initialize(item)
	{
		this.ApolloDataExportHistoryId=item.apolloDataExportHistoryId;
		this.ApolloDataExportId=item.apolloDataExportId;
		this.CreatedOn=item.createdOn;
		this.EventDescription=item.eventDescription;
	}
}
